export default __webpack_public_path__ + "static/media/flayer11.58a64413.jpg";